export default {
  heading: 'Abril Fatface, serif',
  body: 'Sawarabi Mincho, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Saira Extra Condensed',
  googleFonts: [
    'Montserrat:100,200,300,400,500,600,700,800,900',
    'Sawarabi Mincho:200,300,400,500,600,700,800,900',
    'Abril Fatface',
    'Saira Extra Condensed:100,200,300,400,500,600,700,800,900'
  ]
  // customFamilies: ['Din'],
  // customUrls: ['https://www.gonation.biz/fonts/din/din.css'],
}
